/**
 * Hook for PIN login API request
 */
import { useMemo } from "react";
import { useSignup as useSignupContext } from "../../SignupContext";
import { InvalidStateError } from "../../utils/Errors";
import { useApiRequest } from "../../utils/useApiRequest";
/**
 * Hook for managing PIN login API request
 * @returns RequestState object for PIN login
 */
export function useLoginPin() {
    const { apiClient, formValues } = useSignupContext();
    const { state: loginState, execute: executeLogin, reset: resetLoginState, } = useApiRequest();
    return useMemo(() => ({
        execute: async () => {
            // Validate required fields
            if (!formValues.pin) {
                throw new InvalidStateError("Cannot login without PIN", ["pin"]);
            }
            return await executeLogin(async () => {
                const loginParams = {
                    pin: formValues.pin,
                };
                return await apiClient.loginWithData(loginParams);
            });
        },
        isLoading: loginState.isLoading,
        error: loginState.error,
        data: loginState.data,
        reset: resetLoginState,
    }), [apiClient, executeLogin, formValues.pin, loginState, resetLoginState]);
}
